"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var ListLeft = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return (0, jsx_runtime_1.jsx)("div", tslib_1.__assign({}, rest, { children: children }));
};
/**
 * @deprecated Use List from Antd
 * https://ant.design/components/list/
 */
exports.default = (0, houston_styles_1.default)(ListLeft, { label: 'hst-list-item-left' })(function (_a) {
    var theme = _a.theme;
    return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.spacing.inline.xxxs);
});
var templateObject_1;
